import { Folder } from "lucide-react";
import { Outlet } from "react-router";

export function AuthLayout() {
  return (
    <div className="relative flex min-h-screen items-center justify-center bg-bg p-4 overflow-hidden">
      {/* Subtle modern ambient background glows */}
      <div className="pointer-events-none absolute -top-40 -right-40 h-96 w-96 rounded-full bg-primary/10 blur-3xl" />
      <div className="pointer-events-none absolute -bottom-40 -left-40 h-96 w-96 rounded-full bg-blue-400/10 blur-3xl" />

      <div className="relative w-full max-w-sm rounded-2xl border border-border bg-surface p-7 shadow-xl">
        <div className="mb-6 flex flex-col items-center text-center">
          <div className="mb-3 flex h-11 w-11 items-center justify-center rounded-xl bg-gradient-to-tr from-primary to-blue-500 text-white shadow-sm">
            <Folder aria-hidden size={22} className="fill-current" />
          </div>
          <h1 className="text-xl font-bold tracking-tight text-fg">Navigo Drive</h1>
          <p className="mt-1 text-xs text-muted">Secure file storage and collaboration</p>
        </div>
        <Outlet />
      </div>
    </div>
  );
}
